'use strict';
/**
 * Adds a grace period between fired function calls
 * @param  {Function} f Function to call
 * @param  {number} delta Time (in ms) that must pass between calls to f
 * @return {void}
 */
// module.exports = function(f, delta) {
//   var inProgress = false;
//   return function() {
//     if (!inProgress) {
//       f.call(this);
//       inProgress = true;
//       setTimeout(function() {
//         inProgress = false
//       }, delta);
//     }
//   }.bind(this);
// };


module.exports = function throttle(fn, threshhold, scope) {
  threshhold || (threshhold = 250);
  var last,
    deferTimer;
  return function() {
    var context = scope || this;

    var now = +new Date,
      args = arguments;
    if (last && now < last + threshhold) {
      // hold on to it
      clearTimeout(deferTimer);
      deferTimer = setTimeout(function() {
        last = now;
        fn.apply(context, args);
      }, threshhold);
    } else {
      last = now;
      fn.apply(context, args);
    }
  };
};


/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/jsTools/throttle.js
 **/